<!--
 * @Author: your name
 * @Date: 2021-08-31 18:45:03
 * @LastEditTime: 2024-07-31 15:54:05
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\children\programSetting.vue
-->
<template>
  <form-dialog :dialogVisible="addProgramDv" @closeDialog="addProgramCd" :title="$t('schedule.NewProgramInfor')">
    <div class="form-item">
      <el-form label-width="100px" :model="programInfor" :rules="rules" ref="programForm">
        <el-form-item :label="$t('PE.ProgramName')" prop="name">
          <el-input v-model="programInfor.name" @input="nameChange"></el-input>
        </el-form-item>
        <el-form-item :label="$t('PE.Structure')" prop="groupId">
          <el-select v-model="programInfor.groupId" @change="checkState" :placeholder="$t('cscps1')" style="width: 100%;">
            <el-option v-for="(item, index) in groupIdLabel" :key="index" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('PE.DeviceType')" prop="deviceType" v-if="KOMHIDDEN == 1">
          <el-select v-model="programInfor.deviceType" :placeholder="$t('cscps2')" style="width: 100%;" @change="deviceTypeChange">
            <el-option v-for="device in deviceType" :key="device.value" :label="device.label" :value="device.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- 选项分辨率 -->
        <el-form-item :label="$t('PE.Resolution')" v-if="programInfor.resolutionId !=='-1' && programInfor.deviceType === 'Pandora'" prop="resolutionId">
          <el-select v-model="programInfor.resolutionId" :placeholder="$t('cscps3')" style="width: 100%;">
            <el-option :label="$t('PE.CustomResolution')" value="-1" />
            <el-option v-for="(item, index) in resolutionList" :key="index" :label="item.resolution" :value="item.id" />
          </el-select>
        </el-form-item>
        <!-- 自定义分辨率 -->
        <el-form-item :label="$t('PE.Resolution')" v-if="programInfor.resolutionId ==='-1'" prop="resolutionId">
          <div class="input-label">
            <el-form-item prop="w">
              <el-input-number :controls="false" placeholder="W" :min="20" v-model="programInfor.w" style="width: 110px;"></el-input-number>
            </el-form-item>
            <el-form-item prop="h">
              <el-input-number :controls="false" placeholder="H" :min="20" v-model="programInfor.h" style="width: 110px;"></el-input-number>
            </el-form-item>
            <div>
              <el-button icon="el-icon-close" circle size="mini" @click="programInfor.resolutionId = ''"></el-button>
            </div>
          </div>
        </el-form-item>
        <!-- kommanderServers选择 -->
        <el-form-item :label="$t('PE.Device')" v-if="programInfor.deviceType === 'Kommander'" prop="device">
          <el-select v-model="programInfor.device" :placeholder="$t('cscps4')" style="width: 100%;" @change="deviceChange" filterable allow-create>
            <li style="height: 240px; width: 254px; overflow: hidden;">
              <ul style="height: 240px; overflow-y: scroll;" v-infinite-scroll="scrollLoad">
                <el-option :class="{onLine:!deviceState(device.run_state), offLine:deviceState(device.run_state)}" v-for="device in deviceList" :key="device.id" :label="device.name" :value="device.id" :disabled="deviceState(device.run_state)" @click.native="deviceSelect(device.run_state)"></el-option>
              </ul>
            </li>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="submit-device">
      <el-button @click="resetForm('programForm')" round>{{$t('basics.Cancel')}}</el-button>
      <el-button v-if="programInfor.deviceType === 'Pandora'" type="primary" @click="pandoraSubmit('programForm')" round :disabled="isDuplicateName">{{$t('basics.Confirm')}}</el-button>
      <el-button v-else type="primary" @click="KommanderSubmit('programForm')" round :disabled="device.gridState && isDuplicateName">{{$t('basics.Confirm')}}</el-button>
    </div>
  </form-dialog>
</template>

<script>
import FormDialog from '@/components/basics/FormDialog'
import staticResolution from '@static/data/resolution.json';
import superClone from '@/assets/scripts/superClone.js'
import { mPagination } from "@/components/basics/mixins";

const deviceType = [
  { value: 'Pandora', label: 'Pandora' },
  { value: 'Kommander', label: 'Kommander' }
]

export default {
  name: 'ProgramSettings',
  mixins: [mPagination],
  props: {
    // programInfor: {
    //   type: Object,
    //   required: true,
    //   default: () => { }
    // },
    addProgramDv: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      resolutionList: [],
      groupIdLabel: [],
      gridList: [],
      deviceType,
      deviceList: [],
      device: {
        current: 0,
        limit: 12,
        page: 1,
        deviceInfo: null,
        gridState: true,
      },
      isDuplicateName: false,
      rules: {
        name: [{ required: true, message: this.$t('cscps5'), trigger: 'blur' }],
        groupId: [{ required: true, message: this.$t('cscps6'), trigger: 'blur' }],
        deviceType: [{ required: true, message: this.$t('cscps7'), trigger: 'blur' }],
        device: [{ required: true, message: this.$t('cscps8'), trigger: 'blur' }],
        resolutionId: [{ required: true, message: this.$t('cscps9'), trigger: 'change' }]
      },
      KOMHIDDEN: 0,
      programInfor: {
        name: "play_" + new Date().getTime(),
        groupId: 0,
        resolutionId: 0,
        w: '',
        h: '',
        device: '',
        deviceType: 'Pandora',
        examine: true
      }
    }
  },
  async created() {
    this.KOMHIDDEN = parseInt(process.env.VUE_APP_KOM_HIDDEN);
    this.resolutionList = superClone(staticResolution);
    await this.$http.post("/admin/access/groupList", {}, data => {
      this.groupIdLabel = this.resetSelectOptions(superClone(data));
    });
    await this.localInit();
    await this.checkState(this.programInfor.groupId);
    await this.getDeviceList();
  },
  mounted() {
    // 重置节目名称
    this.programInfor.name = "play_" + new Date().getTime();
    // 获取画布信息
    this.myWebSocket.onmessage = (value) => {
      // 解析
      let info = JSON.parse(value.data);
      // 判断
      if (info.type !== "kommander_info") { return; }
      if (info.data.sn !== this.device.deviceInfo.sn) { return; }
      this.device.gridState = false;
      // 解析
      let CanvasInfo = this.getCanvasInfo(info);
      this.programInfor.w = CanvasInfo.w;
      this.programInfor.h = CanvasInfo.h;
      this.gridList = CanvasInfo.gridList;
    };
  },
  methods: {
    nameChange(name) {
      this.isDuplicateName = true;
      this.$http.post("/admin/play/isDuplicateName", { name }, () => {
        this.isDuplicateName = false;
      });
    },
    checkState(id) {
      let organize = this.groupIdLabel.find((item) => item.id === id);
      if (!organize) {
        this.programInfor.groupId = parseInt(this.$cookies.get("group_id"));
        return;
      }
      this.programInfor.examine = !!(organize.check_state & 2);
      // console.log(!!(organize.check_state & 2));
    },
    resetForm() {
      this.addProgramCd(false);
    },
    KommanderSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let resolution = `${this.programInfor.w}x${this.programInfor.h}`;
          this.enterProgram('add', this.programInfor.name, this.programInfor.groupId, resolution, this.programInfor.examine);
          this.addProgramCd(false);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 更新画布尺寸信息
    pandoraSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let resolution = "";
          // 保存当前选中的尺寸到本地
          if (this.programInfor.resolutionId === '-1') {
            let resolutionId = this.$uuid.v4();
            resolution = `${this.programInfor.w}x${this.programInfor.h}`;
            let resolutionList = JSON.parse(localStorage.getItem("resolutionList"));
            let resolutionItem = this.resolutionList.find(item => item.resolution === resolution);
            if (resolutionList) {
              if (!resolutionItem) {
                resolutionList.unshift({ id: resolutionId, resolution });
              } else {
                resolutionId = resolutionItem.id;
              }
            } else {
              if (!resolutionItem) {
                resolutionList = [{ id: resolutionId, resolution }];
              } else {
                resolutionId = resolutionItem.id;
              }
            }
            localStorage.setItem("resolutionList", JSON.stringify(resolutionList));
            localStorage.setItem("programInfor", JSON.stringify({
              name: this.programInfor.name,
              groupId: this.programInfor.groupId,
              resolutionId: resolutionId
            }));
          } else {
            let resolutionItem = this.resolutionList.find((item) => item.id == this.programInfor.resolutionId);
            resolution = resolutionItem.resolution;
            localStorage.setItem("programInfor", JSON.stringify({
              name: this.programInfor.name,
              groupId: this.programInfor.groupId,
              resolutionId: resolutionItem.id
            }));
          }
          this.enterProgram('add', this.programInfor.name, this.programInfor.groupId, resolution, this.programInfor.examine, this.programInfor.deviceType, this.gridList);
          this.addProgramCd(false);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 路由跳转到编辑页面
    /**
     * @description: 
     * @param {add/look/edit/copy} type
     * @param {节目名称} name
     * @param {*} groupId
     * @param {分辨率} resolution
     * @param {编辑节目id} id
     * @return {*}
     */
    enterProgram(type, name, groupId, resolution, examine, deviceType = this.programInfor.deviceType, gridList = this.gridList) {
      // 清空所有节目编辑数据
      this.$store.commit("VDR_LIST_CLEAR");
      let wh = resolution.split("x");
      this.$router.push({
        name: 'WindowsIndex',
        query: {
          type,//add/look/edit/copy
          name,
          groupId,
          resolution,
          w: wh[0],
          h: wh[1],
          deviceType,
          examine,
          gridList: JSON.stringify(gridList)
        }
      });
    },
    // 初始化画布尺寸信息
    localInit() {
      //检测是否有本地默认组织结构
      if (localStorage.getItem("programInfor")) {
        let programInfor = JSON.parse(localStorage.getItem("programInfor"));
        this.programInfor.groupId = programInfor.groupId;
        this.programInfor.resolutionId = programInfor.resolutionId
      }
      //检测是否有本地历史尺寸
      if (localStorage.getItem("resolutionList")) {
        let resolutionList = JSON.parse(localStorage.getItem("resolutionList"));
        this.resolutionList.unshift(...resolutionList);
      }
    },
    getDeviceList(list = { group_ids: this.groupIds, limit: 12, page: this.device.page, type_id: 2 }) {
      return this.$http.post("/admin/device/list", list, data => {
        if (data.list && data.list.length > 0) {
          this.deviceList = this.deviceList.concat(data.list);
          this.device.page += 1;
          this.device.current = parseInt(data.count);
        }
      });
    },
    scrollLoad() {
      if (this.deviceList.length >= this.device.current) {
        this.$msg({ showClose: true, message: this.$t('cscps10'), type: 'warning' });
        return;
      }
      this.getDeviceList();
    },
    deviceSelect(state) {
      (state === 0) && this.$msg({ message: this.$t('cscps11'), type: 'warning' });
    },
    deviceState(state) {
      if (state === 0) {
        return true;
      } else {
        return false;
      }
    },
    deviceTypeChange(val) {
      if (val === 'Kommander') {
        this.programInfor.device = '';
        this.device.gridState = true;
      }
    },
    deviceChange(id) {
      let device = this.deviceList.find(device => device.id === id);
      this.device.deviceInfo = device;
      console.log(device);
      let deviceInfo = [{
        id: device.id,
        sn: device.sn,
        name: device.name,
        type_id: device.type_id,
        cache: {}
      }];
      this.$http.post("/admin/Command/generalCommand", {
        request_type: 'set',
        device_select_mode: 'multiple',
        devices_info: encodeURIComponent(JSON.stringify(deviceInfo)),
        commands_info: encodeURIComponent(JSON.stringify([{ type: "kommander_info", data: [] }]))
      }, () => { });
    },
    /**
     * @description: 接收webSocket接收到的设备屏幕信息
     * @param {*} value
     * @return {*}
     */
    getCanvasInfo(info) {
      // let info = JSON.parse(value.data);
      // if (info.type !== "kommander_info") { return; }
      // if (info.data.sn !== sn) { return; }
      // this.device.gridState = false;

      let screenList = info.data.screenList;
      let viewCanvasInfo = info.data.viewCanvasInfo;
      let w = viewCanvasInfo.canvasViewWidth;
      let h = viewCanvasInfo.canvasViewHeight;
      let gridList = [];
      screenList.forEach((screen) => {
        gridList.push({
          x: parseInt(screen.dstRect['leftTop.x']),
          y: parseInt(screen.dstRect['leftTop.y']),
          w: parseInt(screen.dstRect['rightBottom.x'] - screen.dstRect['leftTop.x']),
          h: parseInt(screen.dstRect['rightBottom.y'] - screen.dstRect['leftTop.y']),
          name: screen.name,
          index: screen.index
        });
      });

      return { w, h, gridList };
    },
    addProgramCd(config) {
      this.$emit("addProgramCd", config);
    },
    resetSelectOptions(data, str = "", arr = []) {
      str += "\u00a0\u00a0";
      for (var i = 0; i < data.length; i++) {
        let obj = data[i];
        if (obj.child) {
          obj.name = str + obj.name;
          arr.push(data[i]);
          this.resetSelectOptions(obj.child, str, arr);
        }
      }
      return arr;
    },
  },
  computed: {
    myWebSocket() {
      return this.$store.getters.myWebSocket;
    }
  },
  components: {
    FormDialog
  }
}
</script>

<style>
</style>

<style lang="scss" scoped>
.submit-device {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 22px;
}
</style>